import { createTheme } from '@mui/material/styles';
import { common } from '@mui/material/colors';
const borderRadius = '12px';
export const theme = createTheme({
    palette: {
        primary: {
            main: '#202224',
        },
        secondary: {
            main: '#3B3F42',
        },
        // action: {
        //   selected: '#CC8181',
        //   active: '#CC8181',
        //   hover: '#CC8181',
        //   disabled: '#CC8181',
        //   disabledBackground: '#CC8181',
        //   focus: '#CC8181',
        // },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#202224',
                    borderRadius,
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    borderRadius,
                    boxShadow: '0px 6px 18px 0px rgba(0, 0, 0, 0.39)',
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    // borderRadius,
                    boxShadow: '0px 6px 18px 0px rgba(0, 0, 0, 0.39)',
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: '#202224 !important',
                    color: '#FFF',
                    fontSize: '16px',
                    '&.Mui-selected': {
                        backgroundColor: '#202224 !important',
                    },
                    '&:hover': {
                        backgroundColor: '#202224 !important',
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: '#202224 !important',
                    },
                    '& tr:hover': {
                        backgroundColor: '#202224 !important',
                    },
                },
            },
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    backgroundColor: '#3B3F42',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    color: '#C4CDD0',
                    '&.Mui-selected': {
                        backgroundColor: '#72797D',
                    },
                    '&:hover': {
                        backgroundColor: '#72797D',
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: '#72797D',
                    },
                    '&.voteTarget': {
                        backgroundColor: '#CC8181 !important',
                        color: `${common.white} !important`,
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '16px 22px',
                    color: 'inherit',
                    width: '183px',
                    fontSize: '14px',
                    border: '0px',
                    borderBottom: '1px solid #202224',
                    '&.MuiTableCell-head': {
                        fontSize: '16px',
                    },
                    '&.role': {
                        color: '#CC8181',
                    },
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    padding: '0',
                    borderRadius: '12px',
                    backgroundColor: '#3B3F42',
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: '0',
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    padding: '24px 0',
                    '&:hover': {
                        backgroundColor: '#272A2C',
                    },
                    '&.timer': {
                        backgroundColor: common.white,
                        borderRadius: '0 0 12px 12px',
                    },
                    '&.gameButtonState': {
                        backgroundColor: '#1976D2',
                        zIndex: '100000',
                    },
                    '&.round': {
                        backgroundColor: '#1976D2',
                        borderRadius: '0 0 12px 12px',
                        zIndex: '100000',
                    },
                    '&.disabled': {
                        boxShadow: 'none',
                        background: 'transparent',
                        color: '#899295',
                        cursor: 'inherit',
                    },
                    '&.gameButtonState:hover': {
                        backgroundColor: '#1868B7',
                    },
                    '&.cancel': {
                        zIndex: '100000',
                        padding: '24px 35px',
                    },
                    '&.status': {
                        background: '#161719',
                    },
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    textTransform: 'uppercase',
                    width: '100%',
                    textAlign: 'center',
                    color: common.white,
                    // fontFeatureSettings: 'clig' off, 'liga' off;
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '114.286%',
                },
                secondary: {
                    textTransform: 'uppercase',
                    width: '100%',
                    textAlign: 'center',
                    color: '#1976D2',
                    // fontFeatureSettings: 'clig' off, 'liga' off;
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '114.286%',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    color: '#292C2E',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    borderRadius,
                    background: common.white,
                    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.20), 0px 1px 10px 0px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.14)',
                    '&:hover': {
                        background: '#F0F0F0',
                    },
                    '&.fouls': {
                        background: 'transparent',
                        boxShadow: 'none',
                        color: '#1976D2',
                        fontSize: '14px',
                        fontWeight: '400',
                    },
                    '&.wakeUpButton': {
                        color: common.white,
                        padding: '10px 28px',
                        borderRadius: '4px',
                        backgroundColor: '#1976D2',
                    },
                    '&.Mui-disabled': {
                        boxShadow: 'none',
                        background: 'transparent',
                        color: '#899295',
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius,
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: common.white,
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    background: '#F0F0F0',
                    color: '#292C2E',
                    borderRadius,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    background: '#F0F0F0',
                    color: '#292C2E',
                },
            },
        },
    },
    typography: {
        // allVariants: {
        //   color: common.white,
        //   fontFamily: 'Roboto',
        // },
        h2: {
            color: common.white,
            fontFamily: 'Roboto',
            fontSize: '42px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: 'normal',
        },
        h4: {
            color: common.white,
            fontFamily: 'Roboto',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: 'normal',
        },
        subtitle1: {
            color: '#899295',
            fontFamily: 'Roboto',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
        },
        subtitle2: {
            color: '#899295',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
        },
        body1: {
            color: '#899295',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
        },
    },
});
